import { render, staticRenderFns } from "./sayer2022.vue?vue&type=template&id=4bb9898b&scoped=true&"
import script from "./sayer2022.vue?vue&type=script&lang=js&"
export * from "./sayer2022.vue?vue&type=script&lang=js&"
import style0 from "./sayer2022.vue?vue&type=style&index=0&id=4bb9898b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9898b",
  null
  
)

export default component.exports